import { StepProps } from './types';
import { cn } from '@/utils/class-utils';

export const StepFooter = ({ children, className }: StepProps) => (
  <div className={cn('step-footer flex w-full gap-2', className)}>{children}</div>
);
